module.exports = __webpack_public_path__ + "static/img/game-logo-poker.42bf153.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build922/assets/image/gamelogo/game-logo-poker.png
// module id = vO3z
// module chunks = 0 1 2 3 4 5 6